import protoRoot from "../proto-root";
import ActivityLogVideoSnapshotPreview from "../private/ActivityLogVideoSnapshotPreview";

const name = "takeVideoSnapshotRPCResponse";

function create({ result, event, data }) {
  const TakeVideoSnapshotRPCResponse = protoRoot.lookupType(
    "comm.TakeVideoSnapshotRPCResponse"
  );
  const Result = protoRoot.lookupEnum("Result");

  const response = TakeVideoSnapshotRPCResponse.create({
    result: Result.values[result],
    snapshot: ActivityLogVideoSnapshotPreview.create({ event, data })
  });
  return { payload: response, name };
}

export default {
  create,
  name
};

// message TakeVideoSnapshotRPCResponse {
//     Result result = 1;
//     ActivityLogVideoSnapshotPreview snapshot = 2;
// }
